import { Injectable } from '@angular/core';

import {
  IdentificationType,
  ValueIdentificationType,
} from 'app/consulta-mark-list/interface/formatTo/identificationType';
import { RegisterType } from 'app/consulta-mark-list/enums';
import { OptionComboboxCdOption, OptionComboboxCdSelect } from 'app/core/enums';

@Injectable({
  providedIn: 'root',
})
export class FormatToService {
  constructor() {}

  formatToIdentificationTypeFromBack(key) {
    return ValueIdentificationType[key] || null;
  }

  formatToRegisterType(alertTypeCdOption: string): RegisterType {
    // Agregar en el arreglo los que sean automaticos
    return [
      OptionComboboxCdOption.AlertType_AlertaAutomaticaVariablesGraves,
    ].includes(alertTypeCdOption as OptionComboboxCdOption)
      ? RegisterType.Automatic
      : RegisterType.Manual;
  }

  formatToIdentificationType(key) {
    const identificationType = IdentificationType[key] || null;
    return identificationType ? identificationType : 'Label no encontrado';
  }

  getCdSelectForAlertTypeFromSubarea(subareaCdOption: string): string {
    // El tipo de alerta de siniestros tienen formato diferente al resto
    if (subareaCdOption === OptionComboboxCdOption.Subarea_Siniestros)
      return OptionComboboxCdSelect.AlertType_Siniestros;

    // Se regresa el selector del tipo de alerta
    const stringArr: string[] = subareaCdOption.split('_');
    const suffix = stringArr[stringArr.length - 1];
    const PREFIX_ALERT_TYPE = 'CB_TIPO-ALERTA_';
    return PREFIX_ALERT_TYPE + suffix;
  }
}
